var checkIsTournamentInGroup = function (tournament, id) {
    if (!tournament.grt) {
        return false;
    }
    return tournament.grt.some(function (t) { return t.id === id; });
};
export { checkIsTournamentInGroup };
